/*
  Pluto — jednoznakovky ("vlna"), 26/10

  Česká typografie: jednopísmenná předložka nebo spojka nesmí zůstat sama na
  konci řádku. Skript za k, s, v, z, o, u, a, i (malá i velká) nahradí běžnou
  mezeru pevnou (U+00A0), takže se slovo zalomí na další řádek i s tím, co
  za ním následuje.

  Jak to funguje:
  - projde textové uzly v <body>; vynechá skripty, styly, formulářová pole,
    kód, SVG a cokoli s atributem data-bez-vlny (tím se dá oblast vypnout),
  - nahrazuje jen mezeru, za kterou ve stejném uzlu pokračuje text — samotné
    "S" u velikosti varianty apod. nechá být,
  - když uzel končí jednopísmenným slovem a hned za ním je řádkový prvek
    (odkaz, <strong> …), sváže je přes hranici prvku — viz poznámka u
    slepPresHranici(),
  - MutationObserver hlídá obsah vložený později (šuplík košíku, výsledky
    hledání, přefiltrovaná kolekce, recenze). Sleduje jen přidané uzly, ne změny
    textu, takže se vlastními úpravami nezacyklí.

  Pokladna (checkout) běží mimo šablonu, tam se to neuplatní.
  Ruční spuštění nad částí stránky: window.plutoVlna(element)
*/
(() => {
  if (window.plutoVlna) return

  // Pevná mezera U+00A0 je schválně zapsaná kódem, ne znakem: v editoru by
  // byla neviditelná a snadno by ji někdo přepsal na obyčejnou mezeru.
  const NBSP = String.fromCharCode(0xa0)
  const PRED = '(^|[\\s(\\[„‚"\'«»])'
  const PISMENO = '([ksvzouaiKSVZOUAI])'
  const MEZERA = '[ \\t\\n\\r\\f]'

  const UVNITR = new RegExp(PRED + PISMENO + MEZERA + '+(?=\\S)', 'g')
  const KONCI_PISMENEM = new RegExp(PRED + PISMENO + MEZERA + '*$')
  const RYCHLY_TEST = new RegExp(PRED + '[ksvzouaiKSVZOUAI](?:' + MEZERA + '|$)')
  const MEZERA_NA_KONCI = new RegExp(MEZERA + '+$')
  const MEZERA_NA_ZACATKU = new RegExp('^' + MEZERA + '+')

  const VYNECHAT =
    'script,style,noscript,template,textarea,input,select,option,code,pre,kbd,samp,svg,math,iframe,canvas,' +
    '[contenteditable=""],[contenteditable="true"],[data-bez-vlny]'

  const RADKOVE = new Set(['A', 'STRONG', 'B', 'EM', 'I', 'SPAN', 'SMALL', 'MARK', 'ABBR', 'SUP', 'SUB', 'U', 'S', 'Q', 'CITE', 'TIME', 'DATA'])

  // Odstraní mezery na začátku textu uvnitř prvku (i přes několik prázdných
  // uzlů za sebou). Vrátí, jestli tam nějaká byla.
  function odstranUvodniMezeru(prvek) {
    const chodec = document.createTreeWalker(prvek, NodeFilter.SHOW_TEXT)
    let uzel
    let odstraneno = false
    while ((uzel = chodec.nextNode())) {
      const text = uzel.nodeValue
      const zbytek = text.replace(MEZERA_NA_ZACATKU, '')
      if (zbytek !== text) {
        uzel.nodeValue = zbytek
        odstraneno = true
      }
      if (zbytek.length) break
    }
    return odstraneno
  }

  // "v " + <a> Praze</a>: mezera může být na konci tohohle uzlu, na začátku
  // textu v následujícím prvku, nebo na obou místech. Musí z ní zbyt PRÁVĚ
  // JEDNA pevná mezera — běžné mezery se slévají, pevná ne, takže kdyby
  // vedle ní zůstala i obyčejná, vznikla by viditelně dvojitá mezera.
  function slepPresHranici(text, uzel) {
    const soused = uzel.nextSibling
    if (!soused || soused.nodeType !== 1 || !RADKOVE.has(soused.tagName)) return text
    if (soused.matches(VYNECHAT) || !KONCI_PISMENEM.test(text)) return text

    // Ve flex/grid kontejneru jsou text a následující prvek samostatné položky.
    // Zalomení mezi nimi pevná mezera neovlivní, a na rozdíl od obyčejné
    // (kterou prohlížeč na okraji položky zahodí) by se jen přičetla k mezeře
    // kontejneru. Typicky popisek checkboxu "Souhlasím s <a>obchodními…</a>" —
    // label je inline-flex s gap 8 px.
    const zobrazeni = uzel.parentElement ? getComputedStyle(uzel.parentElement).display : ''
    if (zobrazeni.includes('flex') || zobrazeni.includes('grid')) return text

    const bezMezery = text.replace(MEZERA_NA_KONCI, '')
    const mezeraNaKonci = bezMezery !== text
    const mezeraVSousedovi = odstranUvodniMezeru(soused)

    // Když mezera nebyla ani na jednom místě ("a<b>b</b>"), slova k sobě patří
    // a nic se nepřidává.
    return mezeraNaKonci || mezeraVSousedovi ? bezMezery + NBSP : text
  }

  function upravUzel(uzel) {
    const puvodni = uzel.nodeValue
    if (!puvodni || !RYCHLY_TEST.test(puvodni)) return

    // Víc průchodů kvůli řetězení ("a v lese") — jeden průchod spolkne mezeru,
    // kterou by potřebovalo následující písmeno.
    let text = puvodni
    for (let i = 0; i < 4; i++) {
      const dalsi = text.replace(UVNITR, '$1$2' + NBSP)
      if (dalsi === text) break
      text = dalsi
    }

    text = slepPresHranici(text, uzel)

    if (text !== puvodni) uzel.nodeValue = text
  }

  function projdi(koren) {
    if (!koren) return

    if (koren.nodeType === 3) {
      const rodic = koren.parentElement
      if (rodic && !rodic.closest(VYNECHAT)) upravUzel(koren)
      return
    }

    if (koren.nodeType !== 1 && koren.nodeType !== 11) return
    if (koren.nodeType === 1 && koren.closest(VYNECHAT)) return

    const chodec = document.createTreeWalker(koren, NodeFilter.SHOW_TEXT, {
      acceptNode(uzel) {
        const rodic = uzel.parentElement
        return rodic && !rodic.closest(VYNECHAT) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
      }
    })

    let uzel
    while ((uzel = chodec.nextNode())) upravUzel(uzel)
  }

  const fronta = new Set()
  let naplanovano = false

  const pozorovatel = new MutationObserver((zaznamy) => {
    for (const zaznam of zaznamy) {
      for (const uzel of zaznam.addedNodes) fronta.add(uzel)
    }
    if (naplanovano) return
    naplanovano = true
    setTimeout(() => {
      naplanovano = false
      const davka = [...fronta]
      fronta.clear()
      for (const uzel of davka) {
        if (uzel.isConnected) projdi(uzel)
      }
    }, 0)
  })

  function start() {
    projdi(document.body)
    pozorovatel.observe(document.body, { childList: true, subtree: true })
  }

  window.plutoVlna = projdi

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }
})()
